<template>
    <div>
        <app-search-bar
            v-model.lazy="words"
            :options="searchDropdownOptions"
            :filter.sync="filter"
            :allOption="false"
            class="lb-media-search-bar"
        />
        <unsplash
            v-if="
                filter ===
                $t('Constants.FILTER_OPTION_PROJECT_BACKGROUND_UNSPLASH')
            "
            v-model="localBackground"
            :search-concept="words"
        />
        <gradients
            v-else-if="
                filter ===
                $t('Constants.FILTER_OPTION_PROJECT_BACKGROUND_GRADIENT')
            "
            v-model="localBackground"
        />
        <div
            v-else-if="
                filter ===
                $t('Constants.FILTER_OPTION_PROJECT_BACKGROUND_UPLOAD')
            "
        >
            <project-configuration-image
                :image.sync="localBackgroundImage"
                :can-edit="true"
            />
        </div>
        <!--div class="columns is-multiline">
      <div
        v-for="(color, index) in colors"
        :key="index"
        :style="`${getGradient(color)}`"
        class="column is-half box card"
        @click="changeBackground({ type: 'gradient', value: color })"
      />
    </div-->
    </div>
</template>

<script>
import AppSearchBar from '@/components/AppSearchBar';
import ProjectConfigurationBackgroundGradients from '@/components/ProjectConfigurationBackgroundGradients';
import ProjectConfigurationBackgroundUnsplash from '@/components/ProjectConfigurationBackgroundUnsplash';
import ProjectConfigurationImage from '@/components/ProjectConfigurationImage';
import _ from 'underscore';
export default {
    components: {
        AppSearchBar,
        Gradients: ProjectConfigurationBackgroundGradients,
        Unsplash: ProjectConfigurationBackgroundUnsplash,
        ProjectConfigurationImage,
    },
    model: {
        prop: 'project',
    },
    props: {
        project: {
            type: Object,
            default: () => {
                return {};
            },
        },
        background: {
            type: Object,
            default: () => {
                return { value: {} };
            },
        },
        backgroundImage: {
            type: Object,
            default: () => {
                return { value: {} };
            },
        },
    },
    data() {
        return {
            searchDropdownOptions: [
                this.$t('Constants.FILTER_OPTION_PROJECT_BACKGROUND_UNSPLASH'),
                this.$t('Constants.FILTER_OPTION_PROJECT_BACKGROUND_UPLOAD'),
                this.$t('Constants.FILTER_OPTION_PROJECT_BACKGROUND_GRADIENT'),
            ],
            filter: this.$t(
                'Constants.FILTER_OPTION_PROJECT_BACKGROUND_UNSPLASH'
            ),
            words: undefined,
            localBackground: _.clone(this.background),
            localBackgroundImage: _.clone(this.backgroundImage),
        };
    },
    watch: {
        localBackground: {
            handler() {
                this.$emit('update:background', this.localBackground);
            },
            deep: true,
        },
        localBackgroundImage() {
            this.$emit('update:backgroundImage', this.localBackgroundImage);
        },
    },
    methods: {},
};
</script>

<style></style>
